import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import { createDraggablePaperComponent } from '../../dialog/DraggablePaper';
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'
import PartnerListContainer from '../../../../containers/common/form/modal/PartnerListContainer'



const PaperComponent = createDraggablePaperComponent('draggable-partner-dialog');

const PartnerModal = ({ link, title, open, handleClose, selectedPartner }) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-partner-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-partner-dialog" onClose={handleClose}>
        {title}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <PartnerListContainer link={link} handleClose={handleClose} selectedPartner={selectedPartner} />
      </DialogContent>
    </BootstrapDialog>
  )
}

export default PartnerModal